var scope_0 = require('/home/runner/work/spm-ui-upgrade-helper/spm-ui-upgrade-helper/packages/gatsby-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/home/runner/work/spm-ui-upgrade-helper/spm-ui-upgrade-helper/packages/gatsby-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f51512edf4a25293a678c9bd92c9d7bc.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    